import { Head, Link } from '@inertiajs/react';

import {
    Btn,
    DesignFooter,
    DesignHeader,
    I,
    UtilityBar,
} from '@/Components/Design';

type Props = { slug?: string };

export default function NotFound({ slug }: Props) {
    return (
        <>
            <Head>
                <title>Page not found — injury-lawyer.help</title>
            </Head>
            <div style={{ background: 'var(--paper)', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                <UtilityBar />
                <DesignHeader />

                <section style={{ flex: 1, maxWidth: 720, margin: '0 auto', padding: '120px 32px 80px', textAlign: 'center' }}>
                    <div style={{ fontSize: 12, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 14, fontWeight: 600 }}>
                        Page not found · 404
                    </div>
                    <h1 style={{ fontSize: 56, lineHeight: 1.05, letterSpacing: '-0.025em', marginBottom: 18, fontFamily: 'var(--font-serif)', fontWeight: 500 }}>
                        We couldn't find that page.
                    </h1>
                    {slug ? (
                        <p style={{ fontSize: 17, color: 'var(--ink-soft)', lineHeight: 1.6, marginBottom: 32 }}>
                            No record matched{' '}
                            <code style={{ background: 'var(--paper-deep)', padding: '2px 8px', borderRadius: 6, fontFamily: 'var(--font-mono)', fontSize: 14 }}>
                                /{slug}
                            </code>
                            . It may have been renamed, removed, or never existed.
                        </p>
                    ) : (
                        <p style={{ fontSize: 17, color: 'var(--ink-soft)', lineHeight: 1.6, marginBottom: 32 }}>
                            The page you're looking for has been renamed, removed, or never existed.
                        </p>
                    )}
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Btn kind="primary" size="lg" icon={I.arrow} href="/">Back to home</Btn>
                        <Btn kind="secondary" size="lg" icon={I.search} href="/search">Browse lawyers</Btn>
                    </div>
                    <div style={{ marginTop: 56, padding: '24px 0', borderTop: '1px solid var(--rule)', fontSize: 13, color: 'var(--ink-mute)' }}>
                        Looking for something specific?{' '}
                        <Link href="/practice-areas" style={{ color: 'var(--ember)' }}>Practice areas</Link>
                        {' · '}
                        <Link href="/search" style={{ color: 'var(--ember)' }}>All states</Link>
                        {' · '}
                        <Link href="/resources" style={{ color: 'var(--ember)' }}>Resources</Link>
                    </div>
                </section>

                <DesignFooter />
            </div>
        </>
    );
}
